import { createFileRoute } from "@tanstack/react-router";
import { ProfileLayoutView } from "../views/profile/layout/profile-layout-view";

export const Route = createFileRoute("/_profile")({
  component: ProfileLayoutView,
});
